/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { CellaTariffarioDTO } from './cella-tariffario-dto';


export interface FasciaTariffarioDTO { 
    isee_oltre?: number;
    isee_fino_a?: number;
    la_tua?: boolean;
    celle?: Array<CellaTariffarioDTO>;
}

